<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 16 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.5503 6.05377C15.8432 5.76087 15.8432 5.286 15.5503 4.99311L10.7774 0.220137C10.4845 -0.0727568 10.0096 -0.0727568 9.7167 0.220137C9.42381 0.51303 9.42381 0.987904 9.7167 1.2808L13.9593 5.52344L9.7167 9.76608C9.42381 10.059 9.42381 10.5338 9.7167 10.8267C10.0096 11.1196 10.4845 11.1196 10.7774 10.8267L15.5503 6.05377ZM0 5.52344V6.27344H15.02V5.52344V4.77344H0V5.52344Z"
      :fill="color"
    />
  </svg>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    size?: number;
    color?: string;
  }>(),
  {
    size: 16,
    color: "currentColor",
  },
);
</script>
